define(["require", "exports", "lit", "lit/directives/unsafe-html.js"], function (require, exports, lit_1, unsafe_html_js_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DefaultHTMLRenderer = exports.RecordValue = exports.ListValue = exports.PrimitiveValue = exports.ValueTypeName = exports.ResultProperty = exports.PropertyInfo = exports.RenderContext = exports.Quantity = void 0;
    exports.parsePropertiesFromPropertiesModel = parsePropertiesFromPropertiesModel;
    exports.parsePropertiesFromPropertyDataSet = parsePropertiesFromPropertyDataSet;
    exports.createResultPropertiesFromPropertiesModel = createResultPropertiesFromPropertiesModel;
    exports.createResultPropertiesFromPropertiesData = createResultPropertiesFromPropertiesData;
    ;
    class Quantity extends Number {
        constructor(value, unit) {
            super(value);
            this.unit = unit;
        }
    }
    exports.Quantity = Quantity;
    const RenderContextOptionsDefaults = {};
    class RenderContext {
        constructor(options) {
            this.options = options || Object.assign({}, RenderContextOptionsDefaults);
        }
        copyWithOptions(options) {
            const effectiveOptions = Object.assign({}, this.options, options);
            return new RenderContext(effectiveOptions);
        }
    }
    exports.RenderContext = RenderContext;
    class PropertyInfo {
        constructor({ key, label }) {
            this.key = key;
            this.label = label;
        }
    }
    exports.PropertyInfo = PropertyInfo;
    class ResultProperty extends PropertyInfo {
        constructor({ key, label, value }) {
            super({ key, label });
            this.accessor = value;
        }
        get value() {
            return this.accessor.value;
        }
        renderValue(context, renderer) {
            return this.accessor.render(context, renderer);
        }
        render(context, renderer) {
            return renderer.renderProperty(context, this, this.accessor);
        }
    }
    exports.ResultProperty = ResultProperty;
    var ValueTypeName;
    (function (ValueTypeName) {
        ValueTypeName["String"] = "string";
        ValueTypeName["Number"] = "number";
        ValueTypeName["Date"] = "date";
        ValueTypeName["Action"] = "action";
        ValueTypeName["NamedAction"] = "namedaction";
        ValueTypeName["Link"] = "link";
        ValueTypeName["Image"] = "image";
        ValueTypeName["Quantity"] = "quantity";
        ValueTypeName["TextSnippet"] = "textsnippet";
        ValueTypeName["PropertySet"] = "propertyset";
        ValueTypeName["List"] = "list";
        ValueTypeName["Empty"] = "empty";
        ValueTypeName["HtmlOnly"] = "htmlonly";
        ValueTypeName["Any"] = "any";
    })(ValueTypeName || (exports.ValueTypeName = ValueTypeName = {}));
    function getRenderFunction(renderer, valueTypeName) {
        switch (valueTypeName) {
            case ValueTypeName.String:
                return renderer.renderString;
            case ValueTypeName.Number:
                return renderer.renderNumber;
            case ValueTypeName.Action:
                return renderer.renderAction;
            case ValueTypeName.NamedAction:
                return renderer.renderNamedAction;
            case ValueTypeName.Link:
                return renderer.renderLink;
            case ValueTypeName.Image:
                return renderer.renderImage;
            case ValueTypeName.Quantity:
                return renderer.renderQuantity;
            case ValueTypeName.TextSnippet:
                return renderer.renderTextSnippet;
            default:
                return renderer.renderUnknown;
        }
    }
    // We could create a Prerendered<T>
    // the primitive case might have html representation from the
    // backend
    class PrimitiveValue {
        constructor(html, value, valueType) {
            this.html = html;
            this.value = value;
            this.valueType = valueType;
        }
        render(context, renderer) {
            if (!(context.options.forceRerenderValue && this.value) && this.html) {
                return (0, unsafe_html_js_1.unsafeHTML)(this.html);
            }
            else if (this.value && this.valueType) {
                return getRenderFunction(renderer, this.valueType)(context, this.value);
            }
        }
    }
    exports.PrimitiveValue = PrimitiveValue;
    class ListValue {
        constructor(values, elementType) {
            this.elementValues = values;
            this.elementType = elementType || ValueTypeName.Any;
        }
        get value() {
            return this.elementValues.map(propValue => propValue.value);
        }
        get length() {
            return this.elementValues.length;
        }
        render(context, renderer) {
            return renderer.renderList(context, this, this.elementType);
        }
    }
    exports.ListValue = ListValue;
    class RecordValue {
        constructor(value, elementType) {
            this.valueType = ValueTypeName.PropertySet;
            this.value = value;
            this.elementType = elementType;
        }
        render(context, renderer) {
            return renderer.renderProperties(context, this.value);
        }
    }
    exports.RecordValue = RecordValue;
    const SIMPLE_VALUE_KEYS = ["category", "categoryinstance", "mes:key", "title", "mes:date", "mes:uniformdocid"];
    class DefaultHTMLRenderer {
        renderProperties(context, properties) {
            let sep = (0, lit_1.html) `<span>, </span>`;
            return (0, lit_1.html) `${Object.keys(properties).map((propertyKey, index) => {
                return (0, lit_1.html) `${index > 0 ? sep : lit_1.nothing}${properties[propertyKey].render(context, this)}`;
            })}`;
        }
        renderProperty(context, propertyInfo, valueAccess) {
            return (0, lit_1.html) `<span class="property-label">${propertyInfo.label}:</span> <span class="property-value">${valueAccess.render(context, this)}</span>`;
        }
        renderList(context, list, elementType) {
            // the idea is that we call thex list
            let sep = (0, lit_1.html) `<span>, </span>`;
            if (elementType == ValueTypeName.NamedAction) {
                sep = (0, lit_1.html) `<span class="action-separator">  </span>`;
            }
            return (0, lit_1.html) `${list.elementValues.map((valueAccessor, index) => {
                return (0, lit_1.html) `${index > 0 ? sep : null}${valueAccessor.render(context, this)}`;
            })}`;
        }
        renderNamedAction(context, action) {
            const wrapLink = (link, label) => {
                return (0, lit_1.html) `<a href="${link.href}">${label}</a>`;
            };
            const wrapAction = (action, label) => {
                return (0, lit_1.html) `<a class="action" data-action-object="${JSON.stringify(action)}">${label}</a>`;
            };
            if (action.valueType == ValueTypeName.Link) {
                return wrapLink(action, action.label);
            }
            else if (action.valueType == ValueTypeName.Action) {
                return wrapAction(action.action, action.label);
            }
            return;
        }
        // link refers to the type directly
        // could be also an image.
        renderAction(context, action) {
            return (0, lit_1.html) ``;
        }
        renderLink(context, link) {
            return (0, lit_1.html) ``;
        }
        renderImage(context, link) {
            return (0, lit_1.html) `<img src="${link.href}">`;
        }
        renderTextSnippet(context, snippet) {
            var _a, _b, _c, _d, _e;
            let showContext = (snippet.textsnippet.text_region.context_before || snippet.textsnippet.text_region.context_after) != "";
            let maxChars = Number((_e = (_d = (_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.options) === null || _a === void 0 ? void 0 : _a.themeDescriptor) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.snippet) === null || _e === void 0 ? void 0 : _e.highlightMaxChars);
            if (maxChars && snippet.textsnippet.text_region.text.trim().length > maxChars) {
                showContext = false;
            }
            return (0, lit_1.html) `
    <div>
      ${snippet.textsnippet.text_region.context_before && showContext ? (0, lit_1.html) `<span>${snippet.textsnippet.text_region.context_before}</span>` : lit_1.nothing}
      <em style="${showContext ? "font-weight: bold" : ""}"> 
        ${snippet.textsnippet.text_region.text}
      </em>
      ${snippet.textsnippet.text_region.context_after && showContext ? (0, lit_1.html) `<span>${snippet.textsnippet.text_region.context_after}</span>` : lit_1.nothing}
    </div>
    `;
        }
        renderDate(context, date) {
            return (0, lit_1.html) `${date.toLocaleDateString()}`;
        }
        renderQuantity(context, quantity) {
            return (0, lit_1.html) ``;
        }
        renderString(context, text) {
            return (0, lit_1.html) `${text}`;
        }
        renderNumber(context, num) {
            return (0, lit_1.html) ``;
        }
        renderUnknown(context, value) {
            return (0, lit_1.html) ``;
        }
    }
    exports.DefaultHTMLRenderer = DefaultHTMLRenderer;
    function extractValueTypeFromValue(data) {
        let valueType;
        if ("value" in data) {
            // we have value.
            //data.value.
            const value = data.value;
            if (typeof value == "number") {
                valueType = ValueTypeName.Number;
                return { valueType, value };
            }
            else if (typeof value == "string") {
                valueType = ValueTypeName.String;
                return { valueType, value };
            }
            else if (typeof value == "object") {
                if (value instanceof Date) {
                    valueType = ValueTypeName.Date;
                    return { valueType, value };
                }
                if ("unit" in value && "num" in value) {
                    valueType = ValueTypeName.Quantity;
                    return { valueType, value: new Quantity(value.num, value.unit) };
                }
                else if ("num" in value) {
                    valueType = ValueTypeName.Number;
                    return { valueType, value: Number(value.num) };
                }
                if ("href" in value) {
                    if ("rel" in value) {
                        if (value.rel.indexOf("image") >= 0) {
                            valueType = ValueTypeName.Image;
                        }
                        else {
                            valueType = ValueTypeName.Link;
                        }
                    }
                    return { valueType, value };
                }
                // question `action` value can be also a link
                else if ("action" in value) {
                    // PropertyVactionValue;
                    valueType = ValueTypeName.Action;
                    return { valueType, value };
                }
                else if ("str" in value) {
                    valueType = ValueTypeName.String;
                    // @ts-ignore @todo defne type str
                    return { valueType, value: value.str };
                }
                else if ("textsnippet" in value) {
                    valueType = ValueTypeName.TextSnippet;
                    return { valueType, value };
                }
            }
        }
        else if ("properties" in data) {
            // structured record can also happen at the
            // data level. data: { properties: [] }
            valueType = ValueTypeName.PropertySet;
            return { valueType, value: parsePropertiesFromPropertyDataSet(data.properties) };
        }
        else if ("html" in data) {
            valueType = ValueTypeName.HtmlOnly;
            return { valueType };
        }
        // return {valueType, value: data}
        return { valueType: ValueTypeName.Any };
    }
    function parsePropertiesFromPropertiesModel(model) {
        return parsePropertiesFromPropertyDataSet(model.properties);
    }
    // TODO make unit test
    function parsePropertiesFromPropertyDataSet(properties) {
        let result = {};
        const items = Array.isArray(properties) ? properties : Object.keys(properties);
        for (let i = 0; i < items.length; ++i) {
            const prop = Array.isArray(properties) ? properties[i] : properties[items[i]];
            if (typeof prop != "object") {
                // skip simple types initially
                continue;
            }
            const key = prop.id || items[i];
            ;
            const name = prop.name;
            let valueType;
            let propertyInfo;
            // TODO extract this from the wellnownproperties
            const asList = (key == "actions" || key == "textsnippets");
            if (key == "content" && "data" in prop && prop.data.length == 1) {
                // additional extract "content" as textsnippet.
                let values = [new PrimitiveValue(prop.data[0].html, undefined, ValueTypeName.TextSnippet)];
                result["textsnippets"] = new ResultProperty({ key: "textsnippets", label: "textsnippets", value: new ListValue(values, ValueTypeName.TextSnippet) });
            }
            if (key == "actions" && "properties" in prop) {
                // first try to use properties
                const value = parsePropertiesFromPropertyDataSet(prop.properties);
                const actionKeys = Object.keys(value);
                const namedActions = actionKeys.map(key => {
                    const actionProp = value[key];
                    const valueType = actionProp.accessor.valueType;
                    if (typeof actionProp.value == "object" && ("action" in actionProp.value || "href" in actionProp.value)) {
                        let html = actionProp.accessor instanceof PrimitiveValue ? actionProp.accessor.html : undefined;
                        return new PrimitiveValue(html, Object.assign({ key, label: actionProp.label, valueType }, actionProp.value), ValueTypeName.NamedAction);
                    }
                });
                result[key] = new ResultProperty({ key, label: prop.name, value: new ListValue(namedActions, ValueTypeName.NamedAction) });
                continue;
            }
            if ("data" in prop) {
                let elementTypeName;
                let elementValueAndTypes = prop.data.map((datum) => extractValueTypeFromValue(datum));
                if (elementValueAndTypes.length == 0) {
                    valueType = ValueTypeName.Empty;
                    elementValueAndTypes = [{ valueType: ValueTypeName.Empty }];
                }
                else if (elementValueAndTypes.length > 1) {
                    elementTypeName = elementValueAndTypes.slice(1).reduce((existingType, valueAndType) => {
                        if (existingType == valueAndType.valueType) {
                            return existingType;
                        }
                        return ValueTypeName.Any;
                    }, elementValueAndTypes[0].valueType);
                }
                let values = elementValueAndTypes.map((valueAndType, i) => {
                    const datum = prop.data[i];
                    const valueType = valueAndType.valueType;
                    if (valueType == ValueTypeName.PropertySet) {
                        return new RecordValue(valueAndType.value, valueType);
                    }
                    else {
                        return new PrimitiveValue(datum.html, valueAndType.value, valueType);
                    }
                });
                if (values.length > 1 || asList) {
                    result[key] = new ResultProperty({ key, label: prop.name, value: new ListValue(values, elementTypeName) });
                }
                else if (values.length == 1) {
                    result[key] = new ResultProperty({ key, label: prop.name, value: values[0] });
                }
            }
            // TODO also augment the existing 
            else if ("properties" in prop) {
                const value = parsePropertiesFromPropertyDataSet(prop.properties);
                const keys = Object.keys(value);
                // this is wrapped as property
                if (keys.length == 1 && keys[0] == key) {
                    result[key] = value[key];
                }
                else {
                    result[key] = new ResultProperty({
                        key,
                        label: prop.name,
                        value: new RecordValue(value)
                    });
                }
                if (key == "mes:nested") {
                    // parse nested result
                    continue;
                }
            }
        }
        return result;
    }
    class ResultPropertiesImpl {
        constructor(properties) {
            this.properties = properties;
        }
        get(key) {
            let prop = this.properties[key];
            if (!prop) {
                return;
            }
            // TOOD make sure that the type matches.
            // we can do this by matching the ValueTypeName
            return prop.value;
        }
        getPropertyType(key) {
            let prop = this.properties[key];
            if (!prop) {
                return;
            }
            return prop.value.valueType;
        }
    }
    function createResultPropertiesFromPropertiesModel(model) {
        let resultProps = parsePropertiesFromPropertiesModel(model);
        let resultPropertiesImpl = new ResultPropertiesImpl(resultProps);
        return new Proxy(resultPropertiesImpl, {
            get(target, key) {
                return target.properties[key];
            }
        });
    }
    function createResultPropertiesFromPropertiesData(properties) {
        let resultProps = parsePropertiesFromPropertyDataSet(properties);
        let resultPropertiesImpl = new ResultPropertiesImpl(resultProps);
        return new Proxy(resultPropertiesImpl, {
            get(target, key) {
                return target.properties[key];
            }
        });
    }
});
/*
   Rendering via a templating
   
   There are three usages:
   - single values     {{title}} and {{{title}}}
   - repreated values  {{#mylist}} <span>{{.}}</span> {{/mylist}}
   - multiple values  {{#actions}}} {{url}} {{/actions}}
        
   
*/
/*
<script type="text/x-mustache-template" data-attr-role="group" data-attr-aria-labelledby="result_{{id}}" data-class-name="media mb-clickable-phone" data-attr-data-action-object="{ &quot;toggleOpen&quot;: { &quot;enabledSelector&quot;: &quot;.visible-phone&quot; }}">
  <span class="pull-left media-object {{^mes:thumbnail}}media-object-icon{{/mes:thumbnail}}" aria-hidden="true">
    {{#actions.data[0].value.href?}}<a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone" tabindex="-1">{{/actions.data[0].value.href?}}
    {{#icon?}}
      <img src="{{icon.href}}">
    {{/icon?}}
    {{^icon?}}
      <img src="../img/v2/mb-default-icon.svg" width="100px">
    {{/icon?}}
    {{#actions.data[0].value.href?}}
      <span class="mb-acc">{{category}} - {{#categoryclass?}}{{categoryclass}}{{/categoryclass?}}{{^categoryclass?}}{{extension}}{{/categoryclass?}}</span>
    </a>{{/actions.data[0].value.href?}}
  </span>
  <div class="media-body">
    <h3 class="media-heading" id="result_{{id}}">
      {{#actions.data[0].value.href?}}
        {{^mb:absoluteDocumentUrl?}}
            <a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone">
        {{/mb:absoluteDocumentUrl?}}
        {{#mb:absoluteDocumentUrl?}}
            <a data-action-object='{&quot;copyPath&quot;:{&quot;mb:absoluteDocumentUrl&quot;:&quot;{{mb:absoluteDocumentUrl}}&quot;}}' data-disabled-selector=".visible-phone">
        {{/mb:absoluteDocumentUrl?}}
      {{/actions.data[0].value.href?}}
      {{{title}}}
      {{#actions.data[0].value.href?}}
        <span class="mb-acc">{{category}} - {{#categoryclass?}}{{categoryclass}}{{/categoryclass?}}{{^categoryclass?}}{{extension}}{{/categoryclass?}}</span>
      </a>{{/actions.data[0].value.href?}}
    </h3>
    {{#mb:absoluteDocumentUrl?}}
      <div class="action mb-url-container mb-copy-path-hover" data-action-object='{&quot;copyPath&quot;:{&quot;mb:absoluteDocumentUrl&quot;:&quot;{{mb:absoluteDocumentUrl}}&quot;}}'>
        <div class='mb-copy-path-text'>
          <span role='button' tabindex='0'>{{{ mb:absoluteDocumentUrl }}}</span>
        </div>
        <i class="icon-copy mb-copy-path-hover-icon"></i>
        <span class="mb-acc">{{{i18n.copy_path_action}}}</span>
      </div>
    {{/mb:absoluteDocumentUrl?}}
    <ul class="mb-actions mb-separated hidden-phone mb-visible-open mb-no-print">
      {{#actions.data}} <li class="nowrap">{{{html}}}</li>{{/actions.data}}
      <li class="nowrap"><a role="button" class="action collect" tabindex="0" data-action-object="{&quot;collectResult&quot;:{}}">{{{i18n.Collect}}}</a></li>
    </ul>
    <dl class="mb-metadata mb-comma-separated-values mb-horizontal mb-separated hidden-phone mb-visible-open mb-small">
      <dt class="mb-acc">{{i18n.date}}</dt><dd>{{{mes:date}}}</dd>
      {{#mes:summary}}
        <dt>{{name}}</dt>{{#data}}<dd>{{#actions?}}<span class="mb-dropdown-toggle"><a data-action-object="{&quot;openMenu&quot;: {&quot;propertyId&quot;: &quot;{{property:id}}&quot;, &quot;position&quot;: {{data:position}} }}" class="nowrap">{{/actions?}}{{{html}}}{{#actions?}} <span class="caret"></span></a></span> {{/actions?}}</span></dd>{{/data}}
      {{/mes:summary}}
    </dl>
    {{#content}}
      <p class="mb-content">{{{.}}}</p>
    {{/content}}
    {{#mes:nested.data?}}
      <ul class="mb-nested">
        {{#mes:nested}}
          <div class="media mb-nested" data-action-object="{ &quot;toggleOpen&quot;: { &quot;enabledSelector&quot;: &quot;.visible-phone&quot; }}">
            {{#actions.data[0].value.href?}}
              <a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone">
            {{/actions.data[0].value.href?}}
              <b>{{{title}}}</b>
            {{#actions.data[0].value.href?}}
              </a>
            {{/actions.data[0].value.href?}}
            <ul class="mb-actions mb-separated hidden-phone mb-visible-submenu-open mb-no-print">
              {{#actions.data}} <li class="nowrap"><small>{{{html}}}</small></li>{{/actions.data}}
            </ul>
            <dl class="mb-comma-separated-values mb-separated mb-summarized-description-list mb-small"><dd>{{{mes:date}}}</dd></dl>
          </div>
        {{/mes:nested}}
      </ul>
    {{/mes:nested.data?}}
    <span class="clearfix"></span>
  </div>
</script>
*/
